<div class="container">
    <h1 class="container__title">
      {{'editVehicle' | translate}}
    </h1>

    <p-floatlabel class="container__input" variant="in">
        <input pInputText id="in_label" [(ngModel)]="vehicleName" autocomplete="off" />
        <label for="in_label">
          {{'vehicleName'| translate}}
        </label>
    </p-floatlabel>

    <div class="container__actions">
        <p-button
            (onClick)="submit()"
            class="submit-btn"
            [label]="'saveChanges'|translate"
            [loading]="false"
        />
        <p-button (onClick)="cancel()" [label]="'labels.cancel' | translate" icon="pi pi-times" variant="text" severity="secondary" />
    </div>
</div>
